/**
 * Apache License 2.0 - https://github.com/google/material-design-icons
 * Copyright (c) Google
 */
import type { SVGProps } from 'react';

function MdGraphicEqRotated(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 24 24"
      height="1em"
      width="1em"
      {...props}
    >
      <path
        d="M18 17v-2H6v2zm4-4v-2H2v2zm-8 8v-2h-4v2zm4-12V7H6v2zm-8-4h4V3h-4z"
        stroke="none"
      />
    </svg>
  );
}

export default MdGraphicEqRotated;
